import { useEffect } from "react";
import { usePostHog } from "posthog-js/react";
import { trpc } from "@/lib/trpc";

/**
 * Component that identifies users to PostHog when they're authenticated.
 * This enables user-specific analytics and session recordings.
 */
export function PostHogIdentifier() {
  const posthog = usePostHog();
  const { data: user } = trpc.user.me.useQuery(undefined, {
    retry: false,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (user && posthog) {
      // Identify the user with PostHog
      posthog.identify(user.id, {
        email: user.email,
        name: user.name,
        created_at: user.createdAt,
      });
    } else if (!user && posthog) {
      // Reset PostHog when user logs out
      posthog.reset();
    }
  }, [user, posthog]);

  return null;
}
